// ** Configs

// ** Hook Import
import useFetch from 'src/hooks/useFetch'
import useSWR from 'swr'
import useCrypto from 'src/hooks/useCrypto'

// ** Type
import { ResponsePegawaiInternal } from 'src/types/pegawai-internal'

const usePegawaiInternal = (nik?: string, skip?: boolean) => {
    // ** Hooks
    const { FetchWithPayload } = useFetch()
    const { decryptURI } = useCrypto()

    const payloadPegawaiInternal = {
        url: skip
            ? null
            : `${decryptURI('BYFxAcC4HpoRgOwCYB0cBsKCcAONdpgBjASwGcAPaAQ3BOnAFMAnMgewDtGAbaFxoswCuJEAFtGHEEA')}/${
                  nik ?? ''
              }`,
        method: 'GET'
    }
    const {
        data,
        isLoading: isLoadingPegawaiInternal,
        mutate: mutatePegawaiInternal
    } = useSWR<ResponsePegawaiInternal>(
        [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payloadPegawaiInternal],
        FetchWithPayload
    )

    return {
        dataPegawaiInternal: data && data.data && data.data.personel ? data.data.personel : undefined,
        isLoadingPegawaiInternal,
        mutatePegawaiInternal
    }
}

export default usePegawaiInternal
